import { batch, connect } from 'react-redux';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { updateFilters, UpdateFiltersActionType } from 'src/redux/products';
import { AppThunkDispatch } from 'src/redux/store';
import { Filter, SelectedFilterOption } from 'src/types';
import { FilterOptions } from '../components/FilterOptions';
import { onExpandableContentToggle } from '../modules/actions';
import { actions as filterActions } from '../modules/slice';
import { ExpandableContentTogglePayload } from '../types';

export const mapStateToProps = (
  { products, filter }: ReduxApplicationState,
  ownProps: { filter: Filter },
) => ({
  currencyCode: products.currencyCode,
  filter: ownProps.filter,
  selectedFilterOptions: filter.collections.selectedFilterOptions,
});

export const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
  onSelectFilterOption: (selectedFilterOption: SelectedFilterOption) => {
    batch(() => {
      dispatch(filterActions.selectFilterOption(selectedFilterOption));
      dispatch(updateFilters(UpdateFiltersActionType.FILTER));
    });
  },
  onExpandableContentToggle: (payload: ExpandableContentTogglePayload) =>
    dispatch(onExpandableContentToggle(payload)),
});

export const FilterOptionsContainer = connect(mapStateToProps, mapDispatchToProps)(FilterOptions);
